// roleStore.ts
import create from "zustand";
import { persist } from "zustand/middleware";

interface PagePermission {
  pageId: string;
  permissions: number[];
}

interface RoleFormData {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  roleId: string;
  pagePermissions: PagePermission[];
}

interface RoleStore {
  formData: RoleFormData;
  updateFormData: (data: Partial<RoleFormData>) => void;
  resetForm: () => void;
}

const initialState: RoleFormData = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  roleId: "",
  pagePermissions: [],
};

export const useRoleStore = create<RoleStore>()(
  persist(
    (set) => ({
      formData: initialState,
      updateFormData: (data) =>
        set((state) => ({
          formData: { ...state.formData, ...data },
        })),
      resetForm: () => set({ formData: initialState }),
    }),
    {
      name: "role-management-store",
    }
  )
);
